// Contains formatting functions, useful for formatting values for display.
/** Converts values from ratio to percentage, e.g. 0.1 => "10%". */
export function toPercent(input) {
    return Math.round(input * 100) + "%";
}
